// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FG8XT2LllErZJh {
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: 36px;
  border-radius: 4px;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.FG8XT2LllErZJh p {
  margin: var(--ds-space-100, 8px) var(--ds-space-150, 12px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mirrorCardNotFound": `FG8XT2LllErZJh`
};
export default ___CSS_LOADER_EXPORT___;
